import React from 'react';
import classNames from 'classnames';

import { useTextInput } from '../../../../hooks';
import '../formElement.scss';

export const TextArea = React.forwardRef((props, ref) => {
	const { inputProps, errorMessage } = useTextInput(
		{
			...props,
			type: 'textarea',
		},
		ref
	);

	const inputClassName = classNames(
		'TextareaField-field formElement-field ty-b2',
		props.className,
		{
			'formElement-field--filled': inputProps.value,
			'formElement-field--invalid': inputProps.hasError,
		}
	);

	return (
		<div
			className={classNames('TextareaField formElement formElement-text ValidatedForm-Field', {
				'TextareaField--error': inputProps.hasError,
				'TextareaField--no-label': !inputProps.label,
			})}
		>
			<textarea {...inputProps} className={inputClassName} />

			{inputProps.label && (
				<label className="formElement-label ty-c4" htmlFor={inputProps.id}>
					{inputProps.label}
				</label>
			)}

			{errorMessage && (
				<span className="formElement-message" role="alert">
					{errorMessage}
				</span>
			)}
		</div>
	);
});

export default TextArea;
